var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkBatteryCharge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 51,
    viewBox: "0 0 28 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_b_1_229337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1943 10.7775L20.1943 2.57162C20.1943 1.15135 19.0725 -4.90368e-08 17.6887 -1.09527e-07L9.69322 -4.59018e-07C8.30938 -5.19508e-07 7.18754 1.15135 7.18754 2.57162L7.18754 10.7775C7.18754 12.1977 8.30938 13.3491 9.69322 13.3491L17.6887 13.3491C19.0725 13.3491 20.1943 12.1977 20.1943 10.7775Z",
    fill: "url(#paint0_linear_1_229337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6943 2.57162L19.6943 10.7775C19.6943 11.9339 18.7842 12.8491 17.6887 12.8491L9.69322 12.8491C8.59768 12.8491 7.68754 11.9339 7.68754 10.7775L7.68754 2.57162C7.68754 1.41517 8.59768 0.499999 9.69322 0.5L17.6887 0.5C18.7842 0.5 19.6943 1.41517 19.6943 2.57162Z",
    stroke: "url(#paint1_linear_1_229337)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_b_1_229337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.81101 4.79187H23.5717C25.6758 4.79187 27.3827 6.78803 27.3827 9.24371V46.5483C27.3827 49.009 25.6758 51.0002 23.5717 51.0002H3.81101C1.70692 51.0002 4.99848e-06 49.009 4.99848e-06 46.5483V9.24371C4.99848e-06 6.78803 1.70692 4.79187 3.81101 4.79187Z",
    fill: "url(#paint2_linear_1_229337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81101 5.29187H23.5717C25.3294 5.29187 26.8827 6.98828 26.8827 9.24371V46.5483C26.8827 48.8083 25.3297 50.5002 23.5717 50.5002H3.81101C2.05296 50.5002 0.500005 48.8083 0.500005 46.5483V9.24371C0.500005 6.98827 2.05329 5.29187 3.81101 5.29187Z",
    stroke: "url(#paint3_linear_1_229337)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 23.958,
    y: 18.7738,
    width: 9.24167,
    height: 20.8793,
    rx: 4.62083,
    transform: "rotate(90 23.958 18.7738)",
    fill: "#33E8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 23.958,
    y: 28.7253,
    width: 8.89938,
    height: 20.8793,
    rx: 4.44969,
    transform: "rotate(90 23.958 28.7253)",
    fill: "#33E8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 23.958,
    y: 38.3347,
    width: 9.24167,
    height: 20.8793,
    rx: 4.62083,
    transform: "rotate(90 23.958 38.3347)",
    fill: "#33E8FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_229337",
    x: -10.8125,
    y: -18,
    width: 49.0068,
    height: 49.3491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_229337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_229337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1_229337",
    x: -18,
    y: -13.2081,
    width: 63.3828,
    height: 82.2083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_229337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_229337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_229337",
    x1: 7.92185,
    y1: 0.753632,
    x2: 19.7597,
    y2: 12.2879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_229337",
    x1: 19.1714,
    y1: 0.942294,
    x2: 7.26499,
    y2: 11.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_229337",
    x1: 1.54591,
    y1: 48.3915,
    x2: 37.5014,
    y2: 27.0845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_229337",
    x1: 1.93291,
    y1: 8.42607,
    x2: 36.9373,
    y2: 30.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBatteryCharge);
export default __webpack_public_path__ + "static/media/dark_battery_charge.55e06bc15419d848ad8a749b40af049f.svg";
export { ForwardRef as ReactComponent };